export default "__VITE_ASSET__1a07259f__"